module.exports = __webpack_public_path__ + "img/h-wrap-2-bg-zh.8653fe72.png";